import CheckoutOrderConfirmation from "./components/KlarnaCheckoutOrderConfirmation"

let module = "klarna"

export default [
  {
    path: "checkout/order-confirmation/:id",
    component: CheckoutOrderConfirmation,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
